<!--
 * @Description  : quill-editor 组件封装
 * @Author       : 王帅
 * @Date         : 2024-07-18 10:07:37
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-27 14:23:01
 * @FilePath     : \ngs_platform_manage_admin\src\components\editor\quill_editor.vue
-->
<template>
	<div class="main">
		<el-upload :action="`${$uploadUrl}group1/upload`" list-type="picture-card" id="quill_upload" v-show="showUpload" :http-request="doUpload">
			<i class="el-icon-plus"></i>
		</el-upload>

		<quill-editor class="editor" ref="myTextEditor" v-model="content" :options="editorOption" @change="onEditorChange($event)"></quill-editor>
		<span class="wordNumber" v-if="!readyOnly && maxLength">{{ editorOption.tiLength }}/{{ maxLength }}</span>

		<!-- 复杂上传图片 -->
		<el-dialog
			:visible.sync="dialogObj.visible"
			:title="dialogObj.title"
			:width="dialogObj.width"
			:close-on-click-modal="false"
			@closed="handleClose"
		>
			<!-- 新增模式 -->
			<div class="center-box" v-if="dialogObj.mode == 'add'">
				<el-upload
					:action="`${$uploadUrl}group1/upload`"
					list-type="picture"
					:http-request="doComplexUpload"
					:file-list="fileList"
					:limit="1"
					:before-upload="beforeUpload"
				>
					<!-- <i class="el-icon-plus"></i> -->
					<el-button size="small" type="primary">点击上传</el-button>
					<div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
				</el-upload>
				<p>绑定事件名称：<el-input placeholder="请输入（可选）" v-model="eventName"></el-input></p>
				<p>链接指向地址：<el-input placeholder="请输入（可选）" v-model="linkUrl"></el-input></p>
			</div>

			<!-- 编辑模式 -->
			<div class="center-box" v-if="dialogObj.mode == 'edit'">
				<div class="img-box">
					<img :src="dialogObj.imgUrl" alt="" />
				</div>
				<p>绑定事件名称：<el-input placeholder="请输入（可选）" v-model="eventName"></el-input></p>
				<p>链接指向地址：<el-input placeholder="请输入（可选）" v-model="linkUrl"></el-input></p>
			</div>

			<!-- footer 组件 -->
			<div slot="footer" class="dialog-footer text-center">
				<el-button size="small" class="btn" @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary" size="small" class="btn btn-blue" :loading="dialogObj.btnLoading" @click="doSubmit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { addQuillTitle } from 'utils/quill-title.js'
import { uploadToWeb } from 'api/modules/upload'
import { dateFormat } from 'utils/tools'
import { Snowflake } from 'node-snowflake'

const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
	// ['blockquote', 'code-block'], // 引用  代码块
	// [{ header: 1 }, { header: 2 }], // 1、2 级标题
	[{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
	//   [{ script: "sub" }, { script: "super" }], // 上标/下标
	//   [{ indent: "-1" }, { indent: "+1" }], // 缩进
	// [{'direction': 'rtl'}],                         // 文本方向
	[{ size: ['small', 'default', 'large', 'huge'] }], // 字体大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
	[{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
	// [{ font: [] }], // 字体种类
	[{ align: [] }], // 对齐方式
	['clean'], // 清除文本格式
	['link', 'image', 'video'] // 链接、图片、视频
] //工具菜单栏配置

export default {
	props: {
		// 配置选项
		options: {
			type: Array,
			default: () => {
				return []
			}
		},

		// 是否只读
		readyOnly: {
			type: Boolean,
			default: false
		},
		// 最大长度（如果不填就不限制）
		maxLength: {
			type: Number,
			default: null
		},
		// 是否使用复杂上传图片
		isComplexUpload: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			content: null, //内容
			showUpload: false,
			isDisabled: false,
			curRange: null, // 光标位置
			dialogObj: {
				visible: false,
				title: '上传图片',
				width: '800px',
				btnLoading: false,
				mode: 'add',
				imgUrl: ''
			},
			fileList: [],
			// 图片额外参数
			eventName: '',
			linkUrl: '',
			curNode: null
		}
	},
	methods: {
		// 初始化富文本
		initEditor(content) {
			let quill = this.$refs.myTextEditor.quill
			quill.root.innerHTML = content
		},
		// 值发生变化
		onEditorChange(editor) {
			this.content = editor.html
			this.$emit('input', editor.html)
			if (this.maxLength) {
				editor.quill.deleteText(this.maxLength, 1)
				if (this.content == '') {
					this.editorOption.tiLength = 0
				} else {
					this.editorOption.tiLength = editor.quill.getLength() - 1
				}
			}
		},

		// 覆盖默认上传
		doUpload(file) {
			let that = this
			// 获取富文本组件实例
			let quill = this.$refs.myTextEditor.quill

			// 图片参数
			let formData = new FormData()
			formData.append('file', file.file)
			formData.append('path', dateFormat('yyyy-mm-dd'))
			formData.append('output', 'json')

			// 上传
			uploadToWeb(formData)
				.then((res) => {
					// 获取光标所在位置
					let length = this.curRange.index
					// 插入图片，res为服务器返回的图片链接地址
					quill.insertEmbed(length, 'image', this.$uploadUrl + res.data.path)
					// 调整光标到最后
					quill.setSelection(length + 1)
				})
				.catch((err) => {
					that.$message.error('图片上传服务器失败！')
					return false
				})
		},

		// 上传前的图片格式监测
		beforeUpload(file) {
			let acceptType = ['jpg', 'png', 'jpeg']
			let curType = file.name.substring(file.name.lastIndexOf('.') + 1)
			if (acceptType.find((x) => x === curType || x === curType.toLowerCase())) {
				return true
			}

			// 格式校验不通过
			this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
			return false
		},

		// 复杂上传
		doComplexUpload(file) {
			let that = this

			let nameArr = file.file.name.split('.')
			let suffix = nameArr[nameArr.length - 1]
			let _name = `${this.$SnowFlake.nextId()}_${this.$generateRandomString()}.${suffix}`
			// 图片参数
			let formData = new FormData()
			formData.append('file', file.file)
			formData.append('path', dateFormat('yyyy-mm-dd'))
			formData.append('output', 'json')
			formData.append('filename', _name)

			// 上传
			uploadToWeb(formData)
				.then((res) => {
					this.fileList = [
						{
							name: file.file.name,
							url: this.$uploadUrl + res.data.path
						}
					]
				})
				.catch((err) => {
					that.$message.error('图片上传服务器失败！')
					return false
				})
		},

		// 确定
		doSubmit() {
			// 获取富文本组件实例
			let quill = this.$refs.myTextEditor.quill

			// 如果是编辑模式
			if (this.dialogObj.mode == 'edit') {
				this.curNode.dataset.eventName = this.eventName
				this.curNode.dataset.linkUrl = this.linkUrl
				this.dialogObj.visible = false

				// 手动触发编辑器更新
				quill.insertText(0, ' ')
				setTimeout(() => {
					quill.deleteText(0, 1)
				}, 1000)
				return
			}

			// 如果是新增模式
			if (this.fileList.length == 0) {
				this.$message.error('请上传图片！')
				return
			}
			let image = new Image()
			image.src = this.fileList[0].url
			image.dataset.eventName = this.eventName
			image.dataset.linkUrl = this.linkUrl
			image.dataset.id = Snowflake.nextId()

			// 获取光标所在位置
			let length = this.curRange.index
			// 插入图片，res为服务器返回的图片链接地址
			quill.insertEmbed(length, image, image.src, {
				color: 'red',
				width: '100px'
			})
			// 调整光标到最后
			quill.setSelection(length + 1)
			this.dialogObj.btnLoading = true
			setTimeout(() => {
				this.dialogObj.visible = false
				this.dialogObj.btnLoading = false
			}, 1000)
		},

		// 编辑图片
		editImg(image) {
			// 如果图片是以前插入的 没有id 直接return
			if (!image.dataset.id) {
				return
			}
			// 找到当前图片
			this.curNode = document.querySelector('.quill-editor img[data-id="' + image.dataset.id + '" ]')

			this.dialogObj.mode = 'edit'
			this.dialogObj.visible = true
			this.eventName = image.dataset.eventName
			this.linkUrl = image.dataset.linkUrl
			this.dialogObj.imgUrl = image.src
		},

		// 弹窗关闭
		handleClose() {
			this.dialogObj.visible = false
			this.dialogObj.mode = 'add'
			this.dialogObj.imgUrl = ''
			this.eventName = ''
			this.linkUrl = ''
			this.fileList = []
		}
	},
	mounted() {
		// 设置是否可编辑
		if (this.readyOnly) {
			let quill = this.$refs.myTextEditor.quill
			quill.enable(false)
		}
		addQuillTitle()
		this.editorOption.tiLength = this.$refs.myTextEditor.quill.getLength() - 1

		// 复杂模式下，给所有图片添加点击事件
		if (this.isComplexUpload) {
			let quillDom = document.querySelector('.quill-editor')
			quillDom.addEventListener('click', (event) => {
				if (event && event.target.nodeName == 'IMG') {
					this.editImg(event.target)
				}
			})
		}
	},
	computed: {
		editorOption() {
			let that = this
			// 配置选项
			return {
				modules: {
					toolbar: {
						container: that.options.length > 0 ? that.options : toolbarOptions, // 工具栏
						handlers: {
							image: function(value) {
								// 先记住此刻光标的位置
								that.curRange = this.quill.getSelection()

								if (value) {
									// 简单上传
									if (!that.isComplexUpload) {
										document.querySelector('#quill_upload .el-upload').click()
									} else {
										// 复杂上传 -- 打开弹窗
										that.dialogObj.visible = true
									}
								} else {
									// 此处this 指向的是quill 编辑器自身
									this.quill.format('image', false)
								}
							}
						}
					}
				},

				placeholder: '', //提示
				readyOnly: true, //是否只读
				theme: 'snow', //主题 snow/bubble
				syntax: true, //语法检测
				tiLength: 0 //当前字符长度
			}
		}
	},
	watch: {
		readyOnly(val) {
			let quill = this.$refs.myTextEditor.quill
			quill.enable(!val)
			addQuillTitle()
		}
	}
}
</script>

<style>
.editor {
	line-height: normal !important;
}
.editor .ql-container {
	min-height: 200px;
}
.ql-snow .ql-tooltip[data-mode='link']::before {
	content: '请输入链接地址:';
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
	border-right: 0px;
	content: '保存';
	padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode='video']::before {
	content: '请输入视频地址:';
}

.ql-snow .ql-picker.ql-size {
	width: 80px;
}

.ql-snow .ql-picker.ql-header {
	width: 80px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
	content: '12px';
	font-size: 12px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='default']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='default']::before {
	content: '14px';
	font-size: 14px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
	content: '18px';
	font-size: 18px;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
	content: '24px';
	font-size: 24px;
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
	content: '文本';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
	content: '标题1';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
	content: '标题2';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
	content: '标题3';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
	content: '标题4';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
	content: '标题5';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
	content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
	content: '标准字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
	content: '衬线字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
	content: '等宽字体';
}
.main {
	position: relative;
}
.wordNumber {
	position: absolute;
	bottom: -10px;
	right: 6px;
	color: #909399;
}
</style>
<style lang="less" scoped>
:deep(.center-box) {
	width: 400px;
	margin: 0 auto;

	.el-upload__tip {
		display: inline-block;
		margin-left: 20px;
	}

	.img-box img {
		max-width: 300px;
		max-height: 200px;
	}
}
</style>
